import { useCallback } from "react";
import { updateProfileField, changePassword } from "../api/authApi";
import { useAuth } from "../context/AuthContext";

export const useUpdateProfile = () => {
  const { user, setUser } = useAuth();

  const updateProfileFieldHook = useCallback(async (fieldLabel, value) => {
    const fieldMap = {
      "Account name": "displayName",
      "Primary email": "email",
      "Address": "address",
      "Secondary email": "secondaryEmail",
      "Mobile phone": "phone"
    };

    const apiField = fieldMap[fieldLabel];
    if (!apiField) {
      console.error("Unknown field:", fieldLabel);
      return false;
    }

    try {
      const payload = { [apiField]: value };
      const res = await updateProfileField(payload);

      if (res?.ok === false) return false;

      setUser({
        ...user,
        [apiField]: value
      });

      return true;
    } catch (err) {
      console.error("Error updating profile:", err);
      return false;
    }
  }, [user, setUser]);

  const changePasswordHook = useCallback(async (currentPassword, newPassword) => {
    try {
      await changePassword({ currentPassword, newPassword });
      return true;
    } catch (err) {
      console.error("Error changing password:", err);
      return false;
    }
  }, []);

  return {
    updateProfileField: updateProfileFieldHook,
    changePassword: changePasswordHook
  };
};
